import React from 'react';
import ScrollAnimation from "../components/animations/ScrollAnimation";
import { useTranslation } from 'react-i18next';
import { usePageVariant, useSectionT } from "../contexts/PageVariantContext";

const ABOUT_IMG_IT =
  "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80";
const ABOUT_IMG_RND =
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80";

const About: React.FC = () => {
  const { t } = useTranslation();
  const variant = usePageVariant();
  const sectionT = useSectionT();
  const aboutImg = variant === "rnd" ? ABOUT_IMG_RND : ABOUT_IMG_IT;

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <ScrollAnimation delay={0.2}>
              <h2 className="text-3xl md:text-4xl font-poppins font-bold text-primary-900 mb-6">
                {t(sectionT('about.title'))}
              </h2>
              <div className="w-20 h-1 bg-accent-500 mb-6"></div>
              <p className="text-gray-600 mb-6">
                {t(sectionT('about.content.paragraph1'))}
              </p>
              <p className="text-gray-600 mb-6">
                {t(sectionT('about.content.paragraph2'))}
              </p>
              <button className="px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white font-medium rounded-lg transition-colors">
                {t(sectionT('about.button'))}
              </button>
            </ScrollAnimation>
          </div>
          <div>
            <ScrollAnimation delay={0.4}>
              <div className="relative">
                <div className="absolute inset-0 bg-accent-500 rounded-lg transform rotate-3"></div>
                <img
                  src={aboutImg}
                  alt=""
                  className="relative rounded-lg shadow-xl"
                />
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
